import { Pipe } from '@angular/core';
import { PipeTransform } from '@angular/core';

@Pipe({name: 'yesNo'})
export class YesNoPipe implements PipeTransform {

    transform(value: any) {
        return value ? 'Yes' : 'No';
    }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/pipes/yesNo.pipe.ts